module.exports = __webpack_public_path__ + "static/Sample-3-9146685c5f74e82e858df2503cb37730.png";